import * as React from 'react';
import { capitaliseFirstLetter } from '../../utils';
import { Box } from '../Box';
import * as flexboxStyles from '../common/flexbox.module.css';
import * as styles from './Stack.module.css';

export const Stack = React.forwardRef(function Stack(
  {
    align = 'stretch',
    children,
    className = '',
    element = 'div',
    gap = 'none',
    height = 'auto',
    justify = 'start',
    padding = 'none',
    width = 'auto',
    ...rest
  },
  ref,
) {
  const gapClass = `gap${capitaliseFirstLetter(gap)}`;
  const alignClass = `align${capitaliseFirstLetter(align)}`;
  const justifyClass = `justify${capitaliseFirstLetter(justify)}`;
  
  const combinedClasses = [
    styles.stack,
    flexboxStyles[gapClass],
    flexboxStyles[alignClass],
    flexboxStyles[justifyClass],
    className
  ]
  .filter(Boolean)
  .join(' ');

  return (
    <Box
      className={combinedClasses}
      display="flex"
      element={element}
      height={height}
      padding={padding}
      ref={ref}
      width={width}
      {...rest}
    >
      {children}
    </Box>
  );
});
